import script from "./SecondBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondBar.vue?vue&type=script&setup=true&lang=js"

import "./SecondBar.vue?vue&type=style&index=0&id=14e3dcd0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e3dcd0"]])

export default __exports__